import {Header} from "../component/Header";
import Sticky from "react-stickynode";
import {AppHeader} from "../component/AppHeader";
import {AppFooter} from "../component/AppFooter";
import {AppCopyright} from "../component/AppCopyright";
import {withRouter} from "react-router-dom";
import React from "react";
import {Message} from "../component/Message";

function Container({history, match}) {
    let message = (match.params.msg && decodeURI(match.params.msg)) || "Pokušaj ponovo!"
    console.log("match ", match.params.msg)
    return <><Header/>
        <Sticky innerZ={1}>
            <AppHeader/>
        </Sticky>

        <div className="clearfix"></div>
        <Message history={history} message={message}/>
        <AppFooter/>
        <AppCopyright/>

        <div className="clearfix"></div>
    </>
}

export const MessageContainer = withRouter(({history, match}) => <Container history={history} match={match}/>);